import { IonLabel, IonRouterOutlet, IonTabBar, IonTabs, IonTabButton, IonIcon } from '@ionic/react';
import { createSelector } from '@reduxjs/toolkit';
import { personAdd, personRemove, search } from 'ionicons/icons';
import React from 'react';
import { useSelector } from 'react-redux';
import { Route, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { t } from 'ttag';

import RoutePath from '@custom-types/RoutePath';
import Check from '@pages/Check';
import { CheckAction, CheckType } from '@pages/Check/Enums';
import { generateRoute } from '@services/navigation-service';
import { getCheckOutEnabled, getKioskModeEnabled, getSearchEmailEnabled } from '@state/event';
import { Capacitor } from '~capacitor-plugins/core';

export const Icon = styled(IonIcon)`
  width: 26px;
  height: 26px;
`;

export const Label = styled(IonLabel)`
  font-size: 10px;
`;

export enum Tabs {
  CheckIn = 'checkin',
  CheckOut = 'checkOut',
  Search = 'search',
}

const selector = createSelector(
  getCheckOutEnabled,
  getSearchEmailEnabled,
  getKioskModeEnabled,
  (checkOutEnabled, searchEmailEnabled, kioskModeEnabled) => ({
    checkOutEnabled,
    searchEmailEnabled,
    kioskModeEnabled,
  })
);

const EventTabs = () => {
  const { eventId } = useParams<{ eventId: string }>();
  const { checkOutEnabled, searchEmailEnabled } = useSelector(selector);

  const prevPath = generateRoute(RoutePath.EventDetail, { eventId });
  const props = { prev: prevPath };

  return (
    <IonTabs>
      <IonRouterOutlet>
        <Route
          path={generateRoute(RoutePath.EventCheck)}
          exact
          render={() => <Check {...props} type={CheckType.Scanner} />}
        />
        <Route
          path={generateRoute(RoutePath.EventPeopleSearch)}
          exact
          render={() => <Check {...props} type={CheckType.Manual} />}
        />
      </IonRouterOutlet>
      <IonTabBar slot="bottom">
        {Capacitor.isNativePlatform() && (
          <IonTabButton
            tab={Tabs.CheckIn}
            href={generateRoute(RoutePath.EventCheck, { eventId, action: CheckAction.CheckIn })}
            routerOptions={{ unmount: true }}
          >
            <Icon icon={personAdd} />
            <Label>{t`Check In`}</Label>
          </IonTabButton>
        )}
        {Capacitor.isNativePlatform() && checkOutEnabled && (
          <IonTabButton
            tab={Tabs.CheckOut}
            href={generateRoute(RoutePath.EventCheck, { eventId, action: CheckAction.CheckOut })}
            routerOptions={{ unmount: true }}
          >
            <Icon icon={personRemove} />
            <Label>{t`Check Out`}</Label>
          </IonTabButton>
        )}
        {searchEmailEnabled && (
          <IonTabButton
            tab={Tabs.Search}
            href={generateRoute(RoutePath.EventPeopleSearch, { eventId })}
            routerOptions={{ unmount: true }}
          >
            <Icon icon={search} />
            <Label>{t`Search`}</Label>
          </IonTabButton>
        )}
      </IonTabBar>
    </IonTabs>
  );
};

export default EventTabs;
